import { Loading, PermissionDenied } from '@/components';
import type { FC, PropsWithChildren } from 'react';

import { useTenantManagerPermission } from '../_hooks/permission';
import type { ResourceGuardProps } from '../_types/authentication';

export const TenantManagerResourceGuard: FC<
  PropsWithChildren<ResourceGuardProps>
> = ({ onlyEdit, showDenied, children }) => {
  const permission = useTenantManagerPermission(onlyEdit);

  if (permission.isLoading) {
    return <Loading />;
  }

  return permission.data ? (
    <>{children}</>
  ) : showDenied ? (
    <PermissionDenied />
  ) : null;
};
